<div class="auction-card">
  <div class="auction-card-img-wrap">
    <a class="card-img">
      <img
        [src]="auction?.image?.url || '/assets/images/defualt-image.jpg'"
        [alt]="auction?.name | localizedName"
      />
    </a>
    <!-- Badge Section -->
    <div class="batch" *ngIf="showType">
      <span
        class="badge"
        [ngClass]="auctionType"
        *ngIf="auctionType == 'active'"
        data-translation-key="auction_active_auction"
      >
        <svg
          width="11"
          height="11"
          viewBox="0 0 11 11"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.6777 11H4.83398C4.65599 11 4.51172 10.8557 4.51172 10.6777V10.334C4.51172 9.97798 4.80025 9.68944 5.15625 9.68944V9.30414C5.15625 8.79397 5.57133 8.37889 6.0815 8.37889H9.43022C9.94039 8.37889 10.3555 8.79397 10.3555 9.30414V9.68944C10.7115 9.68944 11 9.97798 11 10.334V10.6777C11 10.8556 10.8556 11 10.6777 11ZM6.96665 7.09722C6.75245 7.38146 6.34829 7.43829 6.06405 7.22402C5.77973 7.00985 5.72299 6.60568 5.93716 6.32134L7.8766 3.74766C8.09087 3.46333 8.49494 3.40659 8.7792 3.62077C9.06353 3.83503 9.12035 4.23911 8.90609 4.52346L6.96665 7.09722ZM2.334 3.60618C2.11973 3.89042 1.71563 3.94725 1.43131 3.73298C1.14707 3.51881 1.09025 3.11473 1.30451 2.83038L3.24397 0.256726C3.45815 -0.027598 3.86231 -0.0844241 4.14657 0.12984C4.43081 0.344103 4.48763 0.748181 4.27337 1.03253L2.334 3.60618ZM3.74767 5.4785C3.27134 5.11956 2.91373 4.67385 2.69008 4.20454L4.94678 1.20984C5.45955 1.29552 5.98651 1.51631 6.46293 1.87534C6.93928 2.23428 7.29689 2.67999 7.52054 3.14921L5.26382 6.14409C4.75108 6.05841 4.22411 5.83751 3.74767 5.4785ZM2.87749 5.56242C3.02753 5.71533 3.18557 5.86196 3.35979 5.99329C3.53409 6.12456 3.71864 6.23606 3.90689 6.33822L3.48668 6.89589L2.45719 6.12018L2.87749 5.56242ZM2.06929 6.63488L3.09878 7.41059L1.15932 9.98436C0.945055 10.2687 0.540977 10.3254 0.256717 10.1112C-0.027607 9.89698 -0.0843477 9.4929 0.12983 9.20856L2.06929 6.63488Z"
          />
        </svg>
        {{ 'auction.active_auction' | translate }}
      </span>

      <span
        class="badge"
        [ngClass]="auctionType"
        *ngIf="auctionType == 'previous'"
        data-translation-key="auction_previous_auction"
      >
        <svg
          width="9"
          height="9"
          viewBox="0 0 9 9"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.731707 3.29268H0V7.46341C0 8.30488 0.695122 9 1.53659 9H7.46341C8.30488 9 9 8.30488 9 7.46341V3.29268H8.26829H0.731707ZM5.67073 4.84756C5.79878 4.70122 6.05488 4.71951 6.18293 4.84756C6.58537 5.21341 6.96951 5.57927 7.37195 5.96342C7.51829 6.10976 7.5 6.34756 7.37195 6.47561C7.0061 6.87805 6.64024 7.2622 6.2561 7.66463C6.10976 7.81098 5.87195 7.79268 5.7439 7.66463C5.59756 7.53659 5.61585 7.28049 5.7439 7.15244C6.01829 6.84146 6.31098 6.54878 6.58537 6.23781C6.27439 5.94512 5.96341 5.65244 5.65244 5.37805C5.5061 5.21342 5.52439 4.97561 5.67073 4.84756ZM4.20732 4.84756C4.33537 4.70122 4.59146 4.71951 4.71951 4.84756C5.12195 5.21341 5.5061 5.57927 5.90854 5.96342C6.05488 6.10976 6.03658 6.34756 5.90854 6.47561C5.54268 6.87805 5.17683 7.2622 4.79268 7.66463C4.64634 7.81098 4.40854 7.79268 4.28049 7.66463C4.13415 7.53659 4.15244 7.28049 4.28049 7.15244C4.55488 6.84146 4.84756 6.54878 5.12195 6.23781C4.81098 5.94512 4.5 5.65244 4.18902 5.37805C4.04268 5.21342 4.06098 4.97561 4.20732 4.84756ZM8.26829 2.56098H9V1.53659C9 0.713415 8.34146 0.0365854 7.51829 0V0.841463C7.51829 1.04268 7.35366 1.20732 7.15244 1.20732C6.95122 1.20732 6.78658 1.02439 6.78658 0.841463V0H2.26829V0.804878C2.26829 1.0061 2.10366 1.17073 1.90244 1.17073C1.70122 1.17073 1.53659 0.987805 1.53659 0.804878V0C0.695122 0 0 0.695122 0 1.53659V2.56098H0.731707H8.26829Z"
          />
        </svg>
        {{ 'auction.previous_auction' | translate }}
      </span>
      <span
        class="badge"
        [ngClass]="auctionType"
        *ngIf="auctionType == 'upcoming'"
        data-translation-key="auction_upcoming_auction"
      >
        <svg
          width="9"
          height="9"
          viewBox="0 0 9 9"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.731707 3.29268H0V7.46341C0 8.30488 0.695122 9 1.53659 9H7.46341C8.30488 9 9 8.30488 9 7.46341V3.29268H8.26829H0.731707ZM5.67073 4.84756C5.79878 4.70122 6.05488 4.71951 6.18293 4.84756C6.58537 5.21341 6.96951 5.57927 7.37195 5.96342C7.51829 6.10976 7.5 6.34756 7.37195 6.47561C7.0061 6.87805 6.64024 7.2622 6.2561 7.66463C6.10976 7.81098 5.87195 7.79268 5.7439 7.66463C5.59756 7.53659 5.61585 7.28049 5.7439 7.15244C6.01829 6.84146 6.31098 6.54878 6.58537 6.23781C6.27439 5.94512 5.96341 5.65244 5.65244 5.37805C5.5061 5.21342 5.52439 4.97561 5.67073 4.84756ZM4.20732 4.84756C4.33537 4.70122 4.59146 4.71951 4.71951 4.84756C5.12195 5.21341 5.5061 5.57927 5.90854 5.96342C6.05488 6.10976 6.03658 6.34756 5.90854 6.47561C5.54268 6.87805 5.17683 7.2622 4.79268 7.66463C4.64634 7.81098 4.40854 7.79268 4.28049 7.66463C4.13415 7.53659 4.15244 7.28049 4.28049 7.15244C4.55488 6.84146 4.84756 6.54878 5.12195 6.23781C4.81098 5.94512 4.5 5.65244 4.18902 5.37805C4.04268 5.21342 4.06098 4.97561 4.20732 4.84756ZM8.26829 2.56098H9V1.53659C9 0.713415 8.34146 0.0365854 7.51829 0V0.841463C7.51829 1.04268 7.35366 1.20732 7.15244 1.20732C6.95122 1.20732 6.78658 1.02439 6.78658 0.841463V0H2.26829V0.804878C2.26829 1.0061 2.10366 1.17073 1.90244 1.17073C1.70122 1.17073 1.53659 0.987805 1.53659 0.804878V0C0.695122 0 0 0.695122 0 1.53659V2.56098H0.731707H8.26829Z"
          />
        </svg>
        {{ 'auction.upcoming_auction' | translate }}
      </span>
    </div>

    <div
      *ngIf="auctionType != 'previous'"
      [class.timer-bg-danger]="auction?.gradual_ending_settings"
    >
      <app-timer
        *ngIf="auctionType != 'previous'"
        [endDate]="
          auction?.timer_end_date ||
          (auction?.gradual_ending_settings &&
          auction?.gradual_ending_settings?.next_item_finish_at
            ? auction?.gradual_ending_settings?.next_item_finish_at
            : (auction?.extended_end_date ||
              auction?.end_date ||
              auction?.auction_end_date))
        "
        [startDate]="auction?.auction_start_date"
        [currentDate]="auction?.current_date"
        [translations]="translations"
        [auc_type]="auctionType"
        [showProgressPar]="false"
        (loadData)="fireTimeEnded()"
        [theme]="'timer-bg-beige card-style'"
        [countInUpcoming]="true"
        [gradualEnding]="auction?.gradual_ending_settings"
      ></app-timer>
    </div>
  </div>
  <div class="auction-card-content">
    <div class="">
      <h6 class="card-data__card-header--name">{{ auction?.name | localizedName }}</h6>

      <ng-container *ngIf="auctionType == 'upcoming'">
        <div class="card-bid d-none" *ngIf="auction?.min_bid">
          <span class="key" data-translation-key="auction_minimum_bid">
            {{ 'auction.minimum_bid' | translate }}:
          </span>
          <span class="val"> {{ auction.min_bid | number }}$ </span>
        </div>
      </ng-container>
    </div>

    <div class="author-and-btn-area">
      <!--
        BXS-3589: Defer the status-dependent action button until the buyer's
        per-auction application status has loaded. The "All Auctions" page
        renders cards from a cached static endpoint and merges per-buyer status
        from a second request; without this gate an Approved/Pending buyer sees
        a brief flash of the wrong "Request to Bid" button.
      -->
      @if (isStatusResolved) {
      <ng-container *ngIf="auctionType != 'previous'">
        <app-request-to-bid-button
          *ngIf="
            !loggedIn ||
            (!auction.request_to_join_status &&
              auction?.auction_buyer_last_record === null &&
              !auction?.invited_buyer &&
              !auction?.accepted_invited_buyer)
          "
          [loggedIn]="loggedIn"
          [auctionSettings]="auction"
          [translations]="translations"
          [horseDetails]="{
            auc_id: auction?.id,
            buyer_document_categories: auction?.buyer_document_categories
          }"
          [theme]="'request'"
          [aucType]="auctionType"
          [terms]="{
            buyer_accepted: auction?.buyer_accepted_seller_terms,
            seller_terms: auction?.seller_terms
          }"
          (fetchData)="loadData()"
          [buyerStatus]="auction?.buyer_status"
          [sellerEmail]="sellerEmail"
          [canBid]="isBlockedOrSuspended && loggedIn && auctionType == 'active'"
        ></app-request-to-bid-button>

        <!-- Blocked/Suspended Status Button -->
        <ng-container *ngIf="isBlockedOrSuspended && loggedIn && auctionType == 'active'">
          <div class="buyer-status-container">
            <button
              class="btn bid-btn blocked-suspended-btn"
              [class.blocked]="isBlocked"
              [class.suspended]="isSuspended"
              disabled
            >
              <ng-container *ngIf="isBlocked">
                <mat-icon class="status-icon">block</mat-icon>
                {{ 'buyer_status.blocked' | translate }}
              </ng-container>
              <ng-container *ngIf="isSuspended && !isBlocked">
                <mat-icon class="status-icon">pause_circle</mat-icon>
                {{ 'buyer_status.suspended' | translate }}
              </ng-container>
            </button>
          </div>
        </ng-container>

        <button
          class="btn bid-btn"
          *ngIf="
            loggedIn &&
            !isBlockedOrSuspended &&
            (auctionType == 'my-auctions' ||
              (auctionType == 'active' && auction.auction_buyer_last_record))
          "
          (click)="handleActions($event, 'place')"
          data-translation-key="auction_place_bid"
        >
          {{ 'auction.place_bid' | translate }}
        </button>

        <ng-container
          *ngIf="
            loggedIn &&
            auction.request_to_join &&
            auction.request_to_join_status == false &&
            auctionType !== 'previous'
          "
          data-translation-key="auction_rejected"
        >
          <button class="rejected bid">
            <span data-translation-key="auction_rejected">
              {{ 'auction.rejected' | translate }}
            </span>
          </button>
        </ng-container>
      </ng-container>
      <button
        class="btn bid-btn"
        *ngIf="
          auctionType == 'my-auctions' ||
          (auctionType == 'upcoming' &&
            loggedIn &&
            !(
              !auction.request_to_join_status &&
              auction?.auction_buyer_last_record === null &&
              !auction?.invited_buyer &&
              !auction?.accepted_invited_buyer
            )) ||
          auctionType == 'previous'
        "
        (click)="handleActions($event, 'place')"
        data-translation-key="auction_view_catalogue"
      >
        {{ 'auction.view_catalogue' | translate }}
      </button>
      } @else {
      <button
        class="btn bid-btn d-flex justify-content-center"
        disabled
        aria-busy="true"
      >
        <mat-spinner [diameter]="20"></mat-spinner>
      </button>
      }
      <a
        *ngIf="auction?.seller_terms != null"
        (click)="goToTermsAndConditions($event)"
        class="ms-3 cursor-pointer terms-link"
        data-translation-key="auction_terms_and_condition"
        >{{ 'auction.terms_and_condition' | translate }}</a
      >
      <button
        class="btn btn-transparent cpy"
        [cdkCopyToClipboard]="
          frontUrl +
          '/buyer/auctions/' +
          auction.slug +
          '?auctionTypePage=' +
          auctionType
        "
        (click)="cpy($event)"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
        >
          <path
            d="M11.6875 5.84375V4.25C11.6875 3.82731 11.5196 3.42193 11.2207 3.12305C10.9218 2.82416 10.5164 2.65625 10.0937 2.65625H4.25C3.82731 2.65625 3.42193 2.82416 3.12305 3.12305C2.82416 3.42193 2.65625 3.82731 2.65625 4.25V10.0937C2.65625 10.5164 2.82416 10.9218 3.12305 11.2207C3.42193 11.5196 3.82731 11.6875 4.25 11.6875H5.84375M11.6875 5.84375H12.75C13.1727 5.84375 13.5781 6.01166 13.877 6.31055C14.1758 6.60943 14.3437 7.01481 14.3437 7.4375V12.75C14.3437 13.1727 14.1758 13.5781 13.877 13.877C13.5781 14.1758 13.1727 14.3437 12.75 14.3437H7.4375C7.01481 14.3437 6.60943 14.1758 6.31055 13.877C6.01166 13.5781 5.84375 13.1727 5.84375 12.75V11.6875M11.6875 5.84375H7.4375C7.01481 5.84375 6.60943 6.01166 6.31055 6.31055C6.01166 6.60943 5.84375 7.01481 5.84375 7.4375V11.6875"
            stroke="black"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>
    <div class="author-and-btn-area" *ngIf="auction?.seller?.user">
      <a
        class="author-area"
        (click)="gotToSellerPage($event, auction?.seller?.id)"
      >
        <div class="author-img">
          <img
            [src]="
              auction?.seller?.user?.profile_picture ||
              '/assets/images/defualt-image.jpg'
            "
            [alt]="auction?.seller?.user?.name"
          />
        </div>
        <div class="author-content">
          <h6>{{ auction?.seller?.user?.name }}</h6>
        </div>
      </a>
    </div>
  </div>
</div>
